import {Component, input} from '@angular/core'
import {FormGroup, ReactiveFormsModule} from '@angular/forms'
import {MatError} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio'

@Component({
  selector: 'spb-green-card',
  templateUrl: './green-card.component.html',
  styleUrl: '../kyc.component.scss',
  imports: [ReactiveFormsModule, MatRadioGroup, MatRadioButton, MatIcon, MatError]
})
export class GreenCardComponent {
  public greenCardForm = input.required<FormGroup>()
}
